import {
    FilterItem,
    SortMenuItem,
    WorkScheduleActions,
    WorkScheduleFilter,
    WorkScheduleGetters,
    WorkScheduleMutations,
    WorkScheduleState,
} from '@/types';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const getDefaultState = () => {
    return {
        search: null,
        sort: [],
        page: 1,
        filter: {
            roles: [],
            isActive: null,
        },
    } as WorkScheduleState;
};

const state: WorkScheduleState = getDefaultState();

const mutations: MutationTree<WorkScheduleState> = {
    [WorkScheduleMutations.SET_SEARCH]: (state, search: string) => (state.search = search),
    [WorkScheduleMutations.SET_SORT]: (state, sort: SortMenuItem[]) => (state.sort = sort),
    [WorkScheduleMutations.SET_PAGE]: (state, page: number) => (state.page = page),
    [WorkScheduleMutations.SET_FILTER](state, filter: WorkScheduleFilter) {
        state.filter.isActive = filter.isActive;
    },
    [WorkScheduleMutations.CLEAR_FILTER](state, item?: FilterItem) {
        switch (item?.field) {
            case 'isActive':
                state.filter.isActive = getDefaultState().filter.isActive;
                break;
            default:
                state.filter.isActive = getDefaultState().filter.isActive;
        }
    },
};

const actions: ActionTree<WorkScheduleState, any> = {
    [WorkScheduleActions.SET_SEARCH]: ({ commit }, search: string) =>
        commit(WorkScheduleMutations.SET_SEARCH, search),
    [WorkScheduleActions.SET_SORT]: ({ commit }, sort: SortMenuItem[]) =>
        commit(WorkScheduleMutations.SET_SORT, sort),
    [WorkScheduleActions.SET_PAGE]: ({ commit }, page: number) =>
        commit(WorkScheduleMutations.SET_PAGE, page),
    [WorkScheduleActions.SET_FILTER]: ({ commit }, filter: WorkScheduleFilter) =>
        commit(WorkScheduleMutations.SET_FILTER, filter),
    [WorkScheduleActions.CLEAR_FILTER]: ({ commit }, item: FilterItem) =>
        commit(WorkScheduleMutations.CLEAR_FILTER, item),
};

const getters: GetterTree<WorkScheduleState, any> = {
    [WorkScheduleGetters.SEARCH]: (state): string | null => state.search,
    [WorkScheduleGetters.SORT]: (state): SortMenuItem[] => state.sort,
    [WorkScheduleGetters.PAGE]: (state): number => state.page,
    [WorkScheduleGetters.FILTER]: (state): WorkScheduleFilter => state.filter,
    [WorkScheduleGetters.DEFAULT_FILTER]: (): WorkScheduleFilter => getDefaultState().filter,
    [WorkScheduleGetters.ACTIVE_FILTERS](state): FilterItem[] {
        const filters: Array<FilterItem> = [];

        if (state.filter.isActive !== null) {
            filters.push({
                field: 'isActive',
                value: state.filter.isActive.value,
                label: state.filter.isActive.label,
            });
        }

        return filters;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};
